<script setup lang="ts">
import type { PageStoryblok } from "~/storyblok/.generated/component-types";

const props = defineProps<{
  metaTags?: PageStoryblok["metaTags"];
}>();

const i18n = useI18n();
const platformStore = usePlatformStore();
const platformConfiguration = computed(
  () => platformStore.getPlatformConfiguration,
);

const title = computed(() => {
  if (props.metaTags?.title) return props.metaTags.title;

  return platformStore.getPlatformName;
});

const ogTitle = computed(() => {
  if (props.metaTags?.og_title) return props.metaTags.og_title;

  return title.value;
});

const description = computed(() => {
  if (props.metaTags?.description) return props.metaTags.description;

  return (
    platformConfiguration.value.configurationDefaultHead.meta.description ||
    i18n.t("metaTags.defaultDescription")
  );
});

const ogDescription = computed(() => {
  if (props.metaTags?.og_description) return props.metaTags.og_description;

  return description.value;
});

const ogImage = computed(() => {
  if (props.metaTags?.og_image) return props.metaTags.og_image;

  return platformConfiguration.value.assets.primaryLogo;
});
</script>

<template>
  <Title>{{ title }}</Title>
  <Meta
    property="og:title"
    :content="ogTitle"
  />

  <Meta
    name="description"
    :content="description"
  />

  <Meta
    property="og:description"
    :content="ogDescription"
  />

  <Meta
    v-if="ogImage"
    property="og:image"
    itemprop="image"
    :content="ogImage"
  />
</template>
